'use client';

import { Box } from '@mui/material';

export default function LoginLayout({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
